import { MapPin, Navigation } from "lucide-react";
import { mapsEmbed, mapsDir } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";

export const Location = ({ content }) => (
  <section id="localizacao" data-testid="location-section" className="py-24 sm:py-32 bg-[#050505] border-y border-zinc-900">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-[1fr_1.5fr] gap-12 items-center">
      <div>
        <SectionHeading eyebrow="Onde estamos" title={content.location_title} intro={content.location_intro} />
        <address data-testid="location-address" className="not-italic mt-10 flex gap-4">
          <MapPin className="text-[#D4AF37] shrink-0 mt-1" size={20} />
          <span className="text-zinc-200 leading-relaxed">
            {content.address_street}<br />
            {content.address_district} · {content.address_city} — {content.address_state}<br />
            CEP {content.address_cep}
          </span>
        </address>
        <a href={mapsDir(content)} target="_blank" rel="noopener noreferrer" data-testid="directions-google-maps" className="btn-gold mt-10">
          <Navigation size={16} /> Como chegar
        </a>
      </div>
      <div className="relative aspect-[4/3] lg:aspect-[16/11] border border-[#D4AF37]/20 overflow-hidden">
        <iframe
          data-testid="embedded-map"
          title="Mapa — Vienna Palace Hotel"
          src={mapsEmbed(content)}
          className="absolute inset-0 w-full h-full grayscale-[60%] invert-[90%] hue-rotate-180 contrast-[90%]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  </section>
);
